import { useMemo, useReducer } from 'react';

export function useInlineStyle(coreStyle, props) {
  const [styleState, dispatch] = useReducer(reducer, {
    hover: false,
    focus: false,
    disabled: false
  });
  const style = useMemo(() => {
    return coreStyle(styleState, props);
  }, [coreStyle, styleState, props]);
  const setStyle = (type, value) => dispatch({ type, value });

  return [style, setStyle];
}
function reducer(state, action) {
  switch (action.type) {
    case 'hover':
      return { ...state, hover: action.value };
    case 'focus':
      return { ...state, focus: action.value };
    case 'disabled':
      return { ...state, focus: action.value };
    default:
      return state;
  }
}
